export type IMobileAdUnitInfo = {
  pid: number;
  mid: number;
  asid: number;
  type: 'banner';
  display: 'inline' | 'interstitial';
  elementid: string;
};

/// ----
/// SP
/// ----

/**
 * SP_s_上部_レクタングル
 */

export const I_MOBILE_SP_S_TOP_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_849_709,
  type: 'banner',
  display: 'inline',
  elementid: 'im-885f9568c3874d38b9adf0fd8bc06dca',
};

export const I_MOBILE_SP_S_TOP_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_849_479,
  type: 'banner',
  display: 'inline',
  elementid: 'm-9eb73b71f8674213971a67864844870e',
};

/**
 * SP_s_下部_レクタングル
 */
export const I_MOBILE_SP_S_BOTTOM_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_849_710,
  type: 'banner',
  display: 'inline',
  elementid: 'im-dba2e3550f5e49779411d7baf7d90801',
};

export const I_MOBILE_SP_S_BOTTOM_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_849_480,
  type: 'banner',
  display: 'inline',
  elementid: 'im-7cbb40605e4a4422b70ceced0003c7e1',
};

export const I_MOBILE_SP_S_INREAD_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_849_714,
  type: 'banner',
  display: 'inline',
  elementid: 'im-f1f08c2f148d460da8373e46b2d4b002',
};

export const I_MOBILE_SP_S_INREAD_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_849_484,
  type: 'banner',
  display: 'inline',
  elementid: 'im-db603bae89f0446098c5090b78845fdf',
};

export const I_MOBILE_SP_COMMON_OVL: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_849_712,
  type: 'banner',
  display: 'inline',
  elementid: 'im-92527085607e4fd98f6def1845356c27',
};

export const I_MOBILE_SP_COMMON_OVL_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_849_482,
  type: 'banner',
  display: 'inline',
  elementid: 'im-2f4c2c1c4a5d4043a3e2e1e7047e513e',
};

export const I_MOBILE_SP_SE_INFEED_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_853_767,
  type: 'banner',
  display: 'inline',
  elementid: 'im-31a8bec542354e89b3ba107961e20d6f',
};

export const I_MOBILE_SP_SE_INFEED_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_853_768,
  type: 'banner',
  display: 'inline',
  elementid: 'im-fe7cad36dbda4bccbd21706893f62cb7',
};

/// ----
/// PC
/// ----
export const I_MOBILE_PC_S_BOTTOM_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_849_700,
  type: 'banner',
  display: 'inline',
  elementid: 'im-0d86254a2eac4b469cd3f535c0a6ec38',
};

export const I_MOBILE_PC_S_BOTTOM_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_743,
  asid: 1_849_470,
  type: 'banner',
  display: 'inline',
  elementid: 'im-91f8c42f1d07401b993a93946f935f74',
};

export const I_MOBILE_PC_S_INREAD_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_849_701,
  type: 'banner',
  display: 'inline',
  elementid: 'im-d6d98bb50c264a7d9631fcb40a6e2826',
};

export const I_MOBILE_PC_S_INREAD_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_743,
  asid: 1_849_471,
  type: 'banner',
  display: 'inline',
  elementid: 'im-26aa1295d47b498dabd699466e1fff7c',
};

export const I_MOBILE_PC_COMMON_OVL: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_853_026,
  type: 'banner',
  display: 'inline',
  elementid: 'im-e0b3aa5e0e0f4aea8d3ec2eb86486c6a',
};

export const I_MOBILE_PC_COMMON_OVL_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_743,
  asid: 1_853_025,
  type: 'banner',
  display: 'inline',
  elementid: 'im-1acdb37526c14705a6aabd2819d58425',
};

export const I_MOBILE_SP_TAG_INFEED_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_849_713,
  type: 'banner',
  display: 'inline',
  elementid: 'im-76eed1a5d86d4a8a9a7eff99621df904',
};

export const I_MOBILE_PC_TAG_INFEED_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_849_705,
  type: 'banner',
  display: 'inline',
  elementid: 'im-a0978b37e5f3454db880bc365b34e12c',
};

export const I_MOBILE_PC_SE_INFEED_RECTANGLE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_853_767,
  type: 'banner',
  display: 'inline',
  elementid: 'im-31a8bec542354e89b3ba107961e20d6f',
};

export const I_MOBILE_PC_SE_INFEED_RECTANGLE_SENSITIVE: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_849_706,
  type: 'banner',
  display: 'inline',
  elementid: 'im-7827d1f33ae84eb18d697c52480476dc',
};

export const createDynamicElementId = (
  adUnit: IMobileAdUnitInfo,
  uniqueSuffix: string
): IMobileAdUnitInfo => {
  return {
    ...adUnit,
    elementid: `${adUnit.elementid}-${uniqueSuffix}`,
  };
};
